module.exports = __webpack_public_path__ + "static/media/challenge-2.2ea57880.jpg";